import classNames from 'classnames'
import React from 'react'
import {makeStyles} from 'tss-react/mui'
import {appBackground} from '../../App.styles'

export const useStyles = makeStyles()((theme) => ({
  contentContainer: {
    background: 'transparent',
    marginLeft: 'auto',
    color: theme.palette.primary.contrastText,
    height: '100%',
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      background: appBackground
    }
  }
}))

interface ContentProps {
  className?: string
  style?: React.CSSProperties
  children?: React.ReactNode
  onClick?: () => void
}

const Content: React.FC<ContentProps> = ({children, className, onClick, ...props}) => {
  const {
    classes: {contentContainer}
  } = useStyles()
  return (
    <div className={classNames(contentContainer, className)} {...props} onClick={onClick}>
      {children}
    </div>
  )
}

export default Content
